// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3uAWB","search":"Settings_search__37u8c","filter":"Settings_filter__10kT-"};